// import { Link } from "react-router-dom";
// import { useState } from "react";
// import ConfirmModal from "components/common/ConfirmModal";
// import { MdVisibility, MdEdit, MdDelete } from "react-icons/md";
// import { getImageUrl } from "utils/imageHelper";
// import ImageViewer from "components/common/ImageViewer";

// export default function ExhibitorTable({ data, onDelete, onRefresh }) {
//   const [deleteId, setDeleteId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [viewerOpen, setViewerOpen] = useState(false);
//   const [viewerSrc, setViewerSrc] = useState(null);

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await onDelete(deleteId);
//       setDeleteId(null);
//       onRefresh();
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//         <table className="w-full text-left">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Exhibitor Logo
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Title
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Exhibitor Category
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Country
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Status
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Eco-Friendly
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600 text-right">
//                 Actions
//               </th>
//             </tr>
//           </thead>

//           <tbody className="divide-y">
//             {data.length === 0 ? (
//               <tr>
//                 <td
//                   colSpan="6"
//                   className="px-6 py-10 text-center text-sm text-gray-500"
//                 >
//                   No exhibitors found
//                 </td>
//               </tr>
//             ) : (
//               data.map((item) => (
//                 <tr key={item._id} className="hover:bg-gray-50 transition">
//                   <td className="px-6 py-4 font-medium text-gray-800">
//                     {item.logo_image && (
//                       <img
//                         src={getImageUrl(item.logo_image)}
//                         alt="Exhibitor Logo"
//                         className="h-24 rounded-xl border cursor-pointer"
//                         onClick={() => {
//                           setViewerSrc(getImageUrl(item.logo_image));
//                           setViewerOpen(true);
//                         }}
//                       />
//                     )}
//                   </td>
//                   <td className="px-6 py-4 font-medium text-gray-800">
//                     {item.title}
//                   </td>
//                   <td className="px-6 py-4 text-gray-600">{item.exhibitor_category.name}</td>
//                   <td className="px-6 py-4 text-gray-600">{item.country}</td>
//                   <td className="px-6 py-4 text-gray-600">{item.status}</td>
//                   <td className="px-6 py-4 text-gray-600">
//                     {item.eco_friendly ? "Yes" : "No"}
//                   </td>
//                   <td className="px-6 py-4">
//                     <div className="flex justify-end gap-3">
//                       <Link
//                         to={`/admin/exhibitors/view/${item._id}`}
//                         title="View"
//                         className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-brand-500"
//                       >
//                         <MdVisibility size={18} />
//                       </Link>
//                       <Link
//                         to={`/admin/exhibitors/edit/${item._id}`}
//                         title="Edit"
//                         className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
//                       >
//                         <MdEdit size={18} />
//                       </Link>
//                       <button
//                         title="Delete"
//                         onClick={() => setDeleteId(item._id)}
//                         className="rounded-lg p-2 text-gray-600 hover:bg-red-50 hover:text-red-600"
//                       >
//                         <MdDelete size={18} />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       <ConfirmModal
//         open={Boolean(deleteId)}
//         title="Delete Exhibitor"
//         message="This action cannot be undone. Do you want to continue?"
//         confirmText="Delete"
//         loading={loading}
//         onConfirm={handleDelete}
//         onCancel={() => setDeleteId(null)}
//       />

//       <ImageViewer
//         open={viewerOpen}
//         onClose={() => setViewerOpen(false)}
//         src={viewerSrc}
//       />
//     </>
//   );
// }

import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import { MdMoreVert, MdVisibility, MdEdit, MdDelete } from "react-icons/md";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";
import { getCountryName } from "../../utils/countryData";

export default function ExhibitorTable({
  data = [],
  startIndex = 0,
  onDelete,
  onRefresh,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  viewButton,
  role = "admin",
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerSrc, setViewerSrc] = useState(null);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleMenu = (e, rowId) => {
    e.stopPropagation();
    if (openDropdownId === rowId) {
      setOpenDropdownId(null);
    } else {
      // Check distance from bottom of screen to flip upward if space is tight
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(rowId);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setDeleteId(null);
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header">
            <tr>
              {role.toLowerCase() !== "exhibitor" && (
                <th className="w-12 text-center">
                  <input
                    type="checkbox"
                    className="table-checkbox"
                    onChange={onSelectAll}
                    checked={
                      data.length > 0 && selectedRows.length === data.length
                    }
                  />
                </th>
              )}
              <th>Logo</th>
              <th>Eamil</th>
              <th>Title</th>
              <th>Category</th>
              <th>Country</th>
              <th className="text-center">Status</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="8"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No exhibitors found
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowId = item._id || index;
                const isChecked = selectedRows.includes(rowId);
                const isMenuOpen = openDropdownId === rowId;
                const isActive =
                  item.status?.toLowerCase() === "active" ||
                  item.status === true;

                return (
                  <tr key={rowId} className="custom-table-row">
                    {/* Select Row Checkbox */}
                    {role.toLowerCase() !== "exhibitor" && (
                      <td className="custom-table-cell text-center">
                        <input
                          type="checkbox"
                          className="table-checkbox"
                          checked={isChecked}
                          onChange={() => onSelectRow && onSelectRow(rowId)}
                        />
                      </td>
                    )}

                    {/* Logo Image */}
                    <td className="custom-table-cell">
                      {item.logo_image ? (
                        <img
                          src={getImageUrl(item.logo_image)}
                          alt={item.title}
                          className="table-logo"
                          onClick={() => {
                            setViewerSrc(getImageUrl(item.logo_image));
                            setViewerOpen(true);
                          }}
                        />
                      ) : (
                        <span style={{ fontSize: "10px", color: "#d1d5db" }}>
                          No logo
                        </span>
                      )}
                    </td>

                    <td className="custom-table-cell">{item.email || "N/A"}</td>
                    {/* Title */}
                    <td className="custom-table-cell">{item.title || "N/A"}</td>

                    {/* Category */}
                    <td className="custom-table-cell ">
                      {item.exhibitor_category?.name || "—"}
                    </td>

                    {/* Country */}
                    <td className="custom-table-cell ">
                      {item.country ? getCountryName(item.country) : "—"}
                    </td>

                    {/* Status Badge */}
                    <td className="custom-table-cell text-center">
                      <span
                        className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
                          isActive
                            ? "bg-[#dcfce7] text-[#16a34a]"
                            : "bg-[#f1f5f9] text-[#64748b]"
                        }`}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>
                    </td>

                    {/* Action Dropdown Menu Cell */}
                    <td className="custom-table-cell relative text-center">
                      <button
                        onClick={(e) => handleToggleMenu(e, rowId)}
                        className="action-menu-btn"
                      >
                        <MdMoreVert className="text-lg" />
                      </button>

                      {/* Smart Directional Dropdown */}
                      {isMenuOpen && (
                        <div
                          ref={dropdownRef}
                          className={`action-dropdown-menu ${
                            openUpward ? "menu-bottom" : "menu-top"
                          }`}
                        >
                          <button
                            onClick={() => {
                              if (viewButton) viewButton(item);
                              setOpenDropdownId(null);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdVisibility className="text-base" />
                            View
                          </button>

                          <div className="action-dropdown-divider" />

                          <Link
                            to={`/admin/exhibitors/edit/${item._id}`}
                            onClick={() => setOpenDropdownId(null)}
                            className="action-dropdown-item"
                          >
                            <MdEdit className="text-base" />
                            Edit
                          </Link>

                          <div className="action-dropdown-divider" />
                          {role.toLowerCase() !== "exhibitor" && (
                            <button
                              onClick={() => {
                                setDeleteId(item._id);
                                setOpenDropdownId(null);
                              }}
                              className="action-dropdown-item"
                            >
                              <MdDelete className="text-base" />
                              Delete
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Delete Modal */}
      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Exhibitor"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />

      {/* Image Previewer */}
      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerSrc}
      />
    </>
  );
}
